import {User} from "../../entities/User";
import {EditBaseCtrl} from "./EditBaseCtrl";
import {EditUserModel} from "../../models/edit/EditUserModel";
import {NotificationService} from "../../services/NotificationService";
import { StateService, StateParams } from "@uirouter/angularjs";

export class EditUserCtrl extends EditBaseCtrl<User> {
    public static $inject = ['$scope','$state','$stateParams','$uibModal','EditUserModel','NotificationService'];
    constructor(public $scope:any, public stateService:StateService,
                public stateParamsService:StateParams,
                public modal:angular.ui.bootstrap.IModalService,
                public editModel:EditUserModel,
                public notifyService:NotificationService) {
        super($scope, stateService, stateParamsService,notifyService, editModel);
        $scope.vm = this;
        this.loadData().then((ok) => {
        });
    }
    save():void{
        this.model.saveData().then((ok)=>{
            if(ok)
              this.stateService.go("admin.users");
        }).catch((exc)=>{
          this.notifyService.notifyError(exc);
        });
    }
    cancel():void{
        this.stateService.go("admin.users");
    }
    setPassword():void{
        this.openPasswordDialog().then((pwd)=>{
            if(pwd != null && pwd.length > 0){
              this.model.entity.password = pwd;
            }
        });
    }
    openPasswordDialog():ng.IPromise<string>{
        console.log("omd");
        var modalInstance:angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/admin.editpassword.html').default,
            controller: 'EditPasswordCtrl',
            size: 'lg',
            resolve: {
            }
        });
        return modalInstance.result;
    }
}
